export function saProjectListHasError(state = false, action) {
    switch (action.type) {
        case 'SA_PROJECT_LIST_HAS_ERROR':
            return action.hasError;

        default:
            return state;
    }
}

export function saProjectListLoading(state = false, action) {
    switch (action.type) {
        case 'SA_PROJECT_LIST_LOADING':
            return action.isLoading;

        default:
            return state;
    }
}

export function saProjects(state = null, action) {
    switch (action.type) {
        case 'SA_PROJECT_LIST_SUCCESS':
            return action.saProjects;

        default:
            return state;
    }
}

export function saProjectQueryParams(state = {
    page: 1, pageSize: 10, partialProjectID: ""//, filter: 'All'
}, action) {
    switch (action.type) {
        case 'SA_PROJECT_QUERY_PARAMS':
            return { ...state, ...action.payload };

        default:
            return state;
    }
}

export function saFlightPostHasError(state = false, action) {
    switch (action.type) {
        case 'SA_FLIGHT_POST_HAS_ERROR':
            return action.hasError;

        default:
            return state;
    }
}

export function saFlightPostLoading(state = false, action) {
    switch (action.type) {
        case 'SA_FLIGHT_POST_LOADING':
            return action.isLoading;

        default:
            return state;
    }
}

export function saFlightPostSuccess(state = null, action) {
    switch (action.type) {
        case 'SA_FLIGHT_POST_SUCCESS':
            return action.payload;

        default:
            return state;
    }
}

export function saCalListHasError(state = false, action) {
    switch (action.type) {
        case 'SA_CAL_LIST_HAS_ERROR':
            return action.hasError;

        default:
            return state;
    }
}

export function saCalListLoading(state = false, action) {
    switch (action.type) {
        case 'SA_CAL_LIST_LOADING':
            return action.isLoading;

        default:
            return state;
    }
}

export function saCal(state = null, action) {
    switch (action.type) {
        case 'SA_CAL_LIST_SUCCESS':
            return action.saCal;

        default:
            return state;
    }
}

export function saCalQueryParams(state = {
    aircraft: "", surveyDate:""
}, action) {
    switch (action.type) {
        case 'SA_PROJECT_QUERY_PARAMS':
            return { ...state, ...action.payload };

        default:
            return state;
    }
}